import React, { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const Datas = lazy(() => import("./datas"));
const DatasDetail = lazy(() => import("./datasDetail"));

const datasRoutes = [
  {
    path: "/Enquiries",
    element: <Datas />,
    auth: authRoles.admin,
  },
  {
    path: "/Enquiries/:id",
    element: <DatasDetail />,
    auth: authRoles.admin,
  },
];

export default datasRoutes;
